








import { defineComponent, computed } from '@vue/composition-api';
import AppText from '@berlin-front/common/components/elements/AppText';
import { useContext } from '@berlin-front/common/composables/context';
import { ThemeContext } from '@berlin-front/common/services/ThemeContext';

export default defineComponent({
  name: 'AppCheckbox',
  components: {
    AppText,
  },

  props: {
    /** テキストラベル（太文字） */
    label: {
      type: String,
      required: true,
      default: '',
    },

    /** チェック値（boolean） */
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  emits: [
    /**
     * inputイベント
     */
    'input',
  ],

  setup(props, { emit }) {
    // v-modelによる双方向bindを伝播させる場合はいくつかやり方があるが、computedでの記述に統一する。
    const inputValue = computed({
      get: () => props.value,
      set: (value) => emit('input', value),
    });
    // 基本カラー(primary)
    const { themeParameter } = useContext(ThemeContext);
    const primaryColor = computed(() => themeParameter.value.primaryColor);

    return {
      inputValue,
      primaryColor,
    };
  },
});
